import { Fragment,useState } from 'react';
import styles from './SingleResult.module.css';

export default function SingleResult({res,idx}){
    const [thresValue,setThresValue]=useState(res.threshold??0.965);

    const clamp = (val) => {
        const num = parseFloat(val);
        if (isNaN(num)) return 0;
        return Math.min(Math.max(num, 0), 1);
    };

    const handleChange = (e) => {
        const val = clamp(e.target.value);
        setThresValue(Number(val.toFixed(3)));
    };

    return(
    <div key={idx} className={styles.resultBlock}>
        <div className={styles.inputEcho}>
            <div>
                Threshold
                <input
                    type="number"
                    min="0"
                    max="1"
                    step="0.001"
                    value={thresValue}
                    onChange={handleChange}
                    className={styles['number-input']}
                />
            </div>
            <hr/>
            <span>{"Input \""+res.input+"\""}</span>
        </div>
        <div className={styles.gridTable}>
            <div className={styles.gridHeader}>
                <div>Model</div>
                <div>Prediction</div>
                <div>Score</div>
                {/* <div>Detail</div> */}
            </div>
            <div className={styles.gridBody}>
            {res.table.map((row, i) => (
                <Fragment key={i}>
                    <div>{row.modelName}</div>
                    <div
                        className={
                            row.predictions[1]>thresValue
                                ? styles.spam
                                : styles.nonSpam
                        }
                    >
                        {row.predictions[1]>thresValue?'SPAM':'Non-SPAM'}
                    </div>
                    <div className={styles['scoreBar-wrap']}
                    >
                    {row.predictions[1]>thresValue?
                        <div
                              className={styles['scoreBar-spam']}
                              style={{
                                    width: `${row.predictions[1] * 100}%`
                              }}
                        >{(row.predictions[1]*100).toFixed(2)+'%'}</div>
                        :
                        <div
                              className={styles['scoreBar-nonSpam']}
                              style={{
                                    width: `${row.predictions[1] * 100}%`
                              }}
                        >{(row.predictions[1]*100).toFixed(2)+'%'}</div>
                    }
                    </div>
                    {/* <div>
                        <button onClick={() => toggleDetail(i)}>Detail</button>
                        {expandedRow === i && (
                            <div className={styles.detailInfo}>{row.detail}</div>
                        )}
                    </div> */}
                </Fragment>
            ))}
            </div>
        </div>
    </div>
    )

}